<template>
  <div>
    <vs-button icon-pack="feather" icon="icon-phone" size="small" type="gradient" color="success" class="mr-2"
      :href="'tel:09039573191'" @click="activePopup = true">
      <span v-if="this.$store.state.windowWidth > this.$store.state.windowsNavMin">
        {{ $t('messages.support_tel') | persian_digits }}
      </span>
    </vs-button>
    <vs-popup :title="$t('messages.support')" :active.sync="activePopup">
      <p>{{ $t('messages.support_description') }}</p>
      <h5 class="text-center"><br />{{ $t('messages.support_tel') | persian_digits }}</h5>
    </vs-popup>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activePopup: false
    }
  }
}
</script>
